import { render, staticRenderFns } from "./DashboardGuide.vue?vue&type=template&id=2d9845f0&scoped=true"
import script from "./DashboardGuide.vue?vue&type=script&lang=js"
export * from "./DashboardGuide.vue?vue&type=script&lang=js"
import style0 from "./DashboardGuide.vue?vue&type=style&index=0&id=2d9845f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9845f0",
  null
  
)

export default component.exports